import SIServiceDetail from "./SIServiceDetail";

export default SIServiceDetail;
